import styled, {css} from "styled-components";

const SectionText = styled.p`
    font-family: Roboto Condensed, serif;
    color: ${({color}) => color ?? 'black'};
    font-size: 15px;  
    font-weight: 300;  
    margin-top: 50px;
    line-height: 1.6;
    max-width: 500px;
    width: 100%;
    white-space: pre-wrap;
    
    ${({resizable}) => resizable && css`
        width: 50%;
        
        @media (max-width: 1140px) {
            width: 100%;
        }
    `} 
`;

export default SectionText;
